import { render, staticRenderFns } from "./importOwnerCar.vue?vue&type=template&id=1ab4d340"
import script from "./importOwnerCar.vue?vue&type=script&lang=js"
export * from "./importOwnerCar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports